"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LftProvider = exports.LiftBrandTokenProvider = exports.LftProviderContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@emotion/react");
var globals = __importStar(require("@lift/design-tokens/dist/ts/globals"));
var yduqs = __importStar(require("@lift/design-tokens/dist/ts/yduqs/default"));
var react_2 = require("react");
var react_helmet_async_1 = require("react-helmet-async");
var defaultTheme = __assign(__assign({}, globals), yduqs);
exports.LftProviderContext = (0, react_2.createContext)({
    tokens: defaultTheme,
    brand: 'yduqs',
    template: 'default'
});
var LftProvider = function (_a) {
    var brand = _a.brand, children = _a.children, _b = _a.template, template = _b === void 0 ? 'default' : _b, _c = _a.tracking, tracking = _c === void 0 ? true : _c, _d = _a.fonts, fonts = _d === void 0 ? true : _d, lftLoad = _a.lftLoad;
    var _e = (0, react_2.useState)(defaultTheme), tokens = _e[0], setTokens = _e[1];
    var _f = (0, react_2.useState)(false), componentLoaded = _f[0], setComponentLoaded = _f[1];
    var _g = (0, react_2.useState)(false), webFontsLoaded = _g[0], setWebFontsLoaded = _g[1];
    var tagManager = "GTM-NQ6QSP7";
    (0, react_2.useEffect)(function () {
        if (typeof window !== 'undefined') {
            if (typeof document.fonts !== 'undefined') {
                setWebFontsLoaded(true);
            }
            else {
                setWebFontsLoaded(true);
            }
        }
        else {
            setWebFontsLoaded(true);
        }
    }, []);
    function verifyAndSetToken(newToken) {
        if (newToken) {
            setTokens(__assign(__assign({}, globals), newToken));
            setComponentLoaded(true);
        }
    }
    function useGTMScript() {
        (0, react_2.useEffect)(function () {
            var head = document.querySelector("head");
            var script = document.createElement("script");
            script.id = "lft-gtm";
            script.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer','".concat(tagManager, "');");
            if (head) {
                head.appendChild(script);
                return function () {
                    head.removeChild(script);
                };
            }
            return;
        }, []);
    }
    ;
    if (tracking) {
        useGTMScript();
    }
    //Tiramos os imports dinámicos por que alguns builders não suportam a realização de build dinámico.
    (0, react_2.useEffect)(function () {
        if (template === 'default') {
            switch (brand) {
                case 'estacio':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/estacio/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'damasio':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/damasio/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'ibmec':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/ibmec/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'idomed':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/idomed/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'wyden':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/wyden/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'yduqs':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/yduqs/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'ensineme':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/ensineme/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'curso-tecnico':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/curso-tecnico/default")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
            }
        }
        else if (template === 'high-contrast') {
            switch (brand) {
                case 'estacio':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/estacio/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'damasio':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/damasio/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'ibmec':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/ibmec/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'idomed':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/idomed/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'wyden':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/wyden/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'yduqs':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/yduqs/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'ensineme':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/ensineme/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
                case 'curso-tecnico':
                    void Promise.resolve().then(function () { return __importStar(require("@lift/design-tokens/dist/ts/curso-tecnico/high-contrast")); }).then(function (newToken) {
                        verifyAndSetToken(newToken);
                    });
                    break;
            }
        }
    }, [brand, template]);
    (0, react_2.useEffect)(function () {
        if (componentLoaded && webFontsLoaded) {
            !!lftLoad && lftLoad(true);
        }
    }, [componentLoaded, webFontsLoaded, lftLoad]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!componentLoaded && ((0, jsx_runtime_1.jsxs)(react_1.ThemeProvider, __assign({ theme: tokens }, { children: [fonts &&
                    (0, jsx_runtime_1.jsx)(react_helmet_async_1.HelmetProvider, { children: (0, jsx_runtime_1.jsxs)(react_helmet_async_1.Helmet, { children: [(0, jsx_runtime_1.jsx)("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }), (0, jsx_runtime_1.jsx)("link", { rel: "stylesheet preload", as: "style", type: "text/css", href: tokens.FontFamilyBaseUrl }), (0, jsx_runtime_1.jsx)("link", { rel: "stylesheet preload", as: "style", type: "text/css", href: tokens.FontFamilyHighlightUrl })] }) }), !!webFontsLoaded && ((0, jsx_runtime_1.jsx)(exports.LftProviderContext.Provider, __assign({ value: { tokens: tokens, brand: brand, template: template } }, { children: children })))] }))) }));
};
exports.LiftBrandTokenProvider = LftProvider;
exports.LftProvider = LftProvider;
